import { Component } from '@angular/core';
import { FuiBaseModal } from 'ngx-fomantic-ui';

export interface IConfirmModalContext {
  title: string;
  message: string;
}

@Component({
  selector: 'monorepo-confirm-modal',
  templateUrl: './force-confirm-modal.component.html',
  styleUrls: ['./force-confirm-modal.component.scss'],
})
export class ForceConfirmModalComponent {
  constructor(public modal: FuiBaseModal<IConfirmModalContext, void, void>) {}
}
